import angular from 'angular';
import copy from 'app/constants';
import {
  ssDialogService,
  loaderService,
  controlDataService,
  controlSharedModelService,
} from 'app/services';
import { alerts, editControlTypeDialog } from 'app/components/global';
import controller from './settings-dialog.controller';
import template from './settings-dialog.html';
import nameMessagesTpl from './name.messages.html';
import controlWeightMessagesTpl from './control.alert-weight.messages.html';
import controlType from '../controlType';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';
require('ng-file-upload/dist/ng-file-upload-shim');// Loads itself

export class dialogService {
  getOptions($event, {
    controlTypes,
    controlTypeList,
  }) {
    return {
      controller,
      controllerAs: 'settingControlDialogVM',
      locals: {
        controlTypes,
        controlTypeList
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.controlAdministration.settingsDialog', [
  ngFileUpload,
  ssDialogService,
  loaderService,
  controlDataService,
  controlSharedModelService,
  copy,
  alerts,
  controlType,
  editControlTypeDialog,
])
  .service('controlSettingsDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('name.messages.html', nameMessagesTpl);
    $templateCache.put('control.alert-weight.messages.html', controlWeightMessagesTpl);
  })
  .name;

console.log('app.components.admin.controlAdministration.settingsDialog created');
